/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.story-block-container {

}

.story-block-container .story-block-slide {
  @apply flex flex-col sm:flex-row justify-center items-stretch max-sm:gap-y-[24px] gap-x-[24px] md:gap-x-[48px]; 
}

.story-block-container .story-block-slide .story-block-left {
  @apply w-fit h-auto sm:max-w-[45%] md:max-w-[35%] lg:max-w-[30%];
}

.story-block-container .story-block-slide .story-block-left .story-block-assets {
  @apply w-fit h-auto relative  sm:max-w-[100%];
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-image {
  @apply w-full h-full object-cover rounded-[12px] block max-w-[340px] max-h-[340px];
}

.story-block-container .story-block-slide .story-block-left .story-block-assets.video-active .story-block-image {
  @apply hidden;
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-video {
  @apply w-full h-auto rounded-[12px] min-h-[340px] min-w-[340px];
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-video .plyr {
  @apply !rounded-[12px];
  background: transparent !important;
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-video .plyr__video-wrapper {
  @apply !rounded-[12px];
  background: transparent !important;
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-video .plyr__controls {
  @apply !hidden;
}

.story-block-container .story-block-slide .story-block-left .story-block-assets.video-active .story-block-video {
  @apply block !important;
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-video iframe {
  @apply w-full h-full aspect-square;
}

.story-block-image-wrapper {
  @apply rounded-xl overflow-hidden ;
}

.story-block-container .story-block-slide .story-block-left .story-block-assets .story-block-logo-wrapper {
  @apply w-full h-full max-w-[45%] max-h-[120px] absolute bottom-0 right-[-1px] flex flex-row justify-center items-center bg-white rounded-[12px] overflow-hidden p-12px;
}

.story-block-container .story-block-slide .story-block-right {
  @apply w-fit h-auto sm:max-w-[55%] md:max-w-[65%] lg:max-w-[70%];
}

.story-block-container .story-block-slide .story-block-right .story-block-right-description {
  @apply font-poppins fs-3 font-normal text-ui-gray-1 max-w-[750px];
}

.story-block-container .story-block-slide .story-block-right .story-block-right-name {
  @apply font-poppins fs-0 mt-20px text-ui-gray-2;
}

.story-block-container .story-block-slide .story-block-right .story-block-right-position {
  @apply font-poppins fs-0 text-ui-gray-2;
}

.story-block-right-buttons {
  @apply flex gap-12px mt-32px h-40px;
}

.story-block-container .story-block-slide .story-block-right .story-block-quotes {
  @apply w-fit h-auto font-poppins text-light-blue fs-9 !leading-[32px] sm:!leading-[56px] md:!leading-[72px] lg:!leading-[77px] font-bold;
}

.story-block-container .story-block-bottom-trackers {
  @apply w-full h-auto flex flex-row md:block gap-x-[16px] mt-24px md:!max-w-[100%] md:!mx-auto;
}

.story-block-container .story-block-bottom-tracker {
  @apply cursor-pointer flex flex-row justify-start items-center w-fit h-auto gap-x-[8px];
}

.story-block-container .story-block-bottom-tracker .story-block-slide-preview-item-bar-wrapper {
  @apply w-fit md:w-[32px] h-auto flex flex-row justify-end items-center;
}

.story-block-container .story-block-bottom-tracker h3 {
  @apply hidden md:block transition-opacity  hover:opacity-100;
  opacity: 0.5;
  transition: opacity 150ms ease;
}

.story-block-container .story-block-bottom-tracker.active h3 {
  opacity: 1;
}

.story-block-container .story-block-bottom-tracker .story-block-slide-preview-item-bar {
  @apply w-[16px] h-[4px] md:w-[16px] md:h-[2px] rounded-[8px];
  transition: width 150ms ease;
}

.story-block-container .story-block-bottom-tracker.active .story-block-slide-preview-item-bar {
  @apply w-[56px] md:w-[32px];
}

.story-block-slide-preview-item-bar.bar-0 {
  @apply bg-light-blue;
}

.story-block-slide-preview-item-bar.bar-1 {
  @apply bg-red;
}

.story-block-slide-preview-item-bar.bar-2 {
  @apply bg-dark-green;
}

.story-block-slide-preview-item-bar.bar-3 {
  @apply bg-light-green;
}

.story-block-slide-preview-item-bar.bar-4 {
  @apply bg-yellow;
}

.story-block-slide-preview-item-bar.bar-5 {
  @apply bg-red;
}

.story-block-slide-preview-item-bar.bar-6 {
  @apply bg-light-blue;
}

.story-block-slide-preview-item-bar.bar-7 {
  @apply bg-light-green;
}

.story-block-slide-preview-item-bar.bar-8 {
  @apply bg-yellow;
}

.story-block-slide-preview-item-bar.bar-9 {
  @apply bg-red;
}

.story-block-slide-preview-item-bar.bar-10 {
  @apply bg-light-blue;
}

/* @media(min-width:768px) {
  .story-block-container .story-block-bottom-trackers {
    max-width: calc(50% - 14px);
    margin-right: 0px;
    margin-left: auto;
  }
} */

@media(min-width:768px) and (max-width: 999px){

  .story-block-container .story-block-slide {
    @apply justify-between;
  }

  .story-block-container #mobileTrackers {
    max-width: 55%;
    margin-right: 0px;
    margin-left: auto;
  }
  .story-block-container #mobileTrackers .story-block-bottom-trackers {
    @apply w-full;
  }
}

/* Click animation */
.story-block-right {
  opacity: 1;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

.story-block-assets {
  animation-duration: 0.45s;
}

.story-block-assets.animate-in,
.story-block-right.animate-in {
  animation-name: slide-fade-in;
}

.story-block-assets.animate-out,
.story-block-right.animate-out {
  animation-name: slide-fade-out;
}

/* Animation fadeIn */
@keyframes slide-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes slide-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* Animation fadeIn */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay1, .overlay2{
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.story-block-slide.animate .overlay1{
    animation-name: fade-in;
    animation-delay: .1s;
  }
  
.story-block-slide.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

